export class PublicUser {
    firstname: string;
    profilePicture: string;
    profilePictureThumbnail: string;

    deserialize(input: any): this {
        this.firstname = input.first_name;
        this.profilePicture = input.profile_picture;
        this.profilePictureThumbnail = input.profile_picture_thumbnail;
        return this;
    }
}
